import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { beginSocialEvent } from 'actions/storylet';

import Loading from 'components/Loading';

import MessageComponent from '../MessageComponent';
import PrimaryButton from '../PrimaryButton';

export class SocialMessage extends Component {
  mounted = false;

  state = {
    isWorking: false,
  };

  componentDidMount = () => {
    this.mounted = true;
  };

  componentWillUnmount = () => {
    this.mounted = false;
  };

  handleClick = async () => {
    const {
      dispatch,
      history,
      data: { relatedId: invitationId },
    } = this.props;
    if (!invitationId) {
      return;
    }

    this.setState({ isWorking: true });

    const data = await dispatch(beginSocialEvent(invitationId, history));

    if (data.isSuccess) {
      history.push('/');
    }
    if (this.mounted) {
      this.setState({ isWorking: false });
    }
  };

  render = () => {
    const { data, disabled } = this.props;
    const { isWorking } = this.state;

    return (
      <MessageComponent data={data}>
        <PrimaryButton disabled={disabled} onClick={this.handleClick}>
          {isWorking ? <Loading spinner small /> : 'Respond'}
        </PrimaryButton>
      </MessageComponent>
    );
  }
}

SocialMessage.propTypes = {
  data: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withRouter(connect()(SocialMessage));